import { publicApi } from '@/lib/api-clients/rest-client';
import { EventType } from '@/types';
import { sendEvent } from '@/utils/analytics';

export interface CheckoutSessionRequest {
  address: string;
  priceId: string;
  email?: string | null;
  promotionCode?: string | null;
  fingerprintRequestId?: string | null;
}

export interface CheckoutSessionResponse {
  sessionId?: string;
  url?: string;
}

export const createCheckoutSession = async (
  data: CheckoutSessionRequest,
): Promise<CheckoutSessionResponse> => {
  const res = await publicApi.post<CheckoutSessionResponse>(
    'capital/checkoutSession',
    data,
    {
      headers: {
        'ngrok-skip-browser-warning': 'true',
      },
    },
  );
  if (data.promotionCode) {
    sendEvent(EventType.PROMO_CODE_USED, { code: data.promotionCode });
  }
  return res;
};
